import { Price, TokenAmount } from '@uniswap/sdk-core'
import { FeeAmount, nearestUsableTick, TickMath } from '@uniswap/v3-sdk'
import JSBI from 'jsbi'

export function formatTokenAmount(amount: TokenAmount | undefined, sigFigs: number) {
  if (!amount) {
    return '-'
  }

  if (JSBI.equal(amount.raw, JSBI.BigInt(0))) {
    return '0'
  }

  if (parseFloat(amount.toFixed(Math.min(sigFigs, amount.token.decimals))) < 0.0001) {
    return '<0.0001'
  }

  return amount.toFixed(Math.min(sigFigs, amount.token.decimals))
}

export function formatPrice(price: Price | undefined, sigFigs: number) {
  if (!price) {
    return '-'
  }
  if (parseFloat(price.toFixed(sigFigs)) > Math.pow(10, 30)) {
    return '∞' // Return the infinite symbol if the value is greater than 10^30 (Custom value chosen)
  }

  if (parseFloat(price.toFixed(sigFigs)) < 0.0000000000000000000000000000001) {
    return '≈0'
  }
  return price.toSignificant(sigFigs)
}

export function formatPriceString(price: string | undefined) {
  if (!price || isNaN(Number(price))) {
    return '-'
  }

  const numericPrice = parseFloat(price)

  if (numericPrice >= 1e35) {
    return '∞'
  }

  if (numericPrice > 0 && numericPrice < 1e-13) {
    return '≈0'
  }

  return price
}

export function formatPriceStringByDecimals(price: string | undefined, decimals: number) {
  if (!price || isNaN(Number(price))) {
    return '-'
  }

  const numericPrice = parseFloat(price)

  // todo: work on infinite value
  if (numericPrice >= Math.pow(10, Math.min(decimals + 12, 17))) {
    return '∞'
  }

  if (numericPrice > 0 && numericPrice < Math.pow(10, -(decimals - 1))) {
    return '≈0'
  }

  return price
}

export function formatPriceStringForPool(
  price: string | undefined,
  tick: number | undefined,
  feeAmount: FeeAmount | undefined
) {
  if (tick && feeAmount) {
    if (!price || isNaN(Number(price))) {
      return '-'
    }

    const numericPrice = parseFloat(price)

    const tickSpacing =
      feeAmount === 10000 ? 200 : feeAmount === 3000 ? 60 : feeAmount === 500 ? 10 : feeAmount === 100 ? 1 : 1
    const maxTickUsable = nearestUsableTick(TickMath.MAX_TICK, tickSpacing)

    if (tick >= maxTickUsable || numericPrice >= 1e36) {
      return '∞'
    }

    if (numericPrice > 0 && numericPrice < 1e-18) {
      return '≈0'
    }

    return price
  } else {
    return '-'
  }
}
